if (!window.customElements.get('read-more-text')) {
  class ReadMoreText extends HTMLElement {
    connectedCallback() {
      this.clip = this.querySelector('[data-clip]');
      this.content = this.querySelector('[data-content]');
      this.toggle = this.querySelector('[data-toggle]');
      this.label = this.querySelector('[data-toggle-label]');

      if (!this.clip || !this.content || !this.toggle) return;

      this.expanded = false;
      this._onToggle = this._onToggle.bind(this);
      this._onReflow = this._onReflow.bind(this);

      this.toggle.addEventListener('click', this._onToggle);

      if (window.ResizeObserver) {
        this._observer = new ResizeObserver(this._onReflow);
        this._observer.observe(this.content);
      }
      window.addEventListener('resize', this._onReflow);

      this._onReflow();
    }

    disconnectedCallback() {
      if (this.toggle) this.toggle.removeEventListener('click', this._onToggle);
      if (this._observer) this._observer.disconnect();
      window.removeEventListener('resize', this._onReflow);
      clearTimeout(this._settleTimer);
    }

    _limit() {
      return parseFloat(getComputedStyle(this).getPropertyValue('--read-more-height')) || 0;
    }

    _collapse(animate) {
      const limit = this._limit();
      if (!limit) return;

      if (animate) {
        this.clip.style.maxHeight = this.content.offsetHeight + 'px';
        void this.clip.offsetHeight; // force reflow so the transition runs
      }

      this.clip.style.maxHeight = limit + 'px';
      this.expanded = false;
      this.setAttribute('data-collapsible', '');
      this.removeAttribute('data-expanded');
      this.toggle.setAttribute('aria-expanded', 'false');
      if (this.label) this.label.textContent = this.toggle.dataset.more;
    }

    _expand() {
      this.clip.style.maxHeight = this.content.offsetHeight + 'px';
      this.expanded = true;
      this.setAttribute('data-expanded', '');
      this.toggle.setAttribute('aria-expanded', 'true');
      if (this.label) this.label.textContent = this.toggle.dataset.less;

      clearTimeout(this._settleTimer);
      this._settleTimer = setTimeout(() => {
        if (this.expanded) this.clip.style.maxHeight = 'none';
      }, 400);
    }

    _release() {
      clearTimeout(this._settleTimer);
      this.clip.style.maxHeight = 'none';
      this.expanded = false;
      this.removeAttribute('data-collapsible');
      this.removeAttribute('data-expanded');
      this.toggle.setAttribute('aria-expanded', 'false');
      if (this.label) this.label.textContent = this.toggle.dataset.more;
    }

    _onToggle() {
      if (this.expanded) {
        this._collapse(true);
      } else {
        this._expand();
      }
    }

    _onReflow() {
      const limit = this._limit();

      if (!limit || this.content.offsetHeight <= limit + 1) {
        this._release();
      } else if (!this.expanded) {
        this._collapse(false);
      }
    }
  }

  customElements.define('read-more-text', ReadMoreText);
}
